import React from 'react';
import { Stack, Typography, Divider } from '@mui/material';
import { dateRangeStyles } from './EarningsScreen.styles';
import { isPayDateUpcoming } from '../../common/date-functions';
import { useTranslateKey } from '../../hooks/useTranslate';


const EarningsRow = ({ week,
  monthlyReport,
  column1,
  column2,
  column3,
  isProcessingFees,
  isTotalRow
}) => {
  const translateUpcoming = useTranslateKey("upcoming");

  // is month end date in the future AND no value for month end earnings
  const monthEndUpcoming = () => {
    if (monthlyReport.earning !== ".0000") {
      return false;
    } else {
      let date = new Date(monthlyReport.StartDate);
      let today = new Date();
      date.setMonth(date.getMonth() + 1);
      date.setDate(15);
      return today < date;
    }
  }

  // if monthly report, check if month end date is in the future
  // if weekly report, display upcoming if week is empty and pay date is in the future
  const displayUpcoming = monthlyReport ?
    monthEndUpcoming() :
    week && week.earning === ".0000" && isPayDateUpcoming(week.StartDate);

  const formattedColumn3 = displayUpcoming ?
    translateUpcoming : column3;

  const stackStyles = {
    backgroundColor: isTotalRow ? "#43C06F1A" : null,
    padding: "18px 24px"
  };

  const typographyVariant = isTotalRow ? "h3" : "h4";
  const typographyColor = isProcessingFees ? "#D03C3C" : null;
  const typographyOpacity = displayUpcoming ? ".5" : null;

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={stackStyles}
      >
        <Stack direction="row" alignItems="center">
          {column1 !== null && (
            <Typography variant={typographyVariant} width="7.5rem">
              {column1}
            </Typography>
          )}
          {column2 !== null && (
            <Stack sx={dateRangeStyles}>
              {column2}
            </Stack>
          )}
        </Stack>
        <Stack justifyContent="center">
          <Typography
            variant={typographyVariant}
            color={typographyColor}
            sx={{ opacity: typographyOpacity }}
          >
            {formattedColumn3}
          </Typography>
        </Stack>
      </Stack>
      {!isTotalRow && !isProcessingFees && <Divider />}
    </>
  );
};

export { EarningsRow };
